/**
 * Shared formatting helpers for dashboard components.
 */

/**
 * Format integer cents to a display currency string (COP locale).
 * Example: 150000 → "$150.000"
 */
export function formatCents(cents: number): string {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(cents)
}
